import React, { Suspense } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import routes from './Routes';

function RouterSwitch()  {
  return (
    <Suspense fallback={<></>}>
      <Switch>
        {
          routes.map(route =>
            <Route
              exact={route.exact}
              path={route.path}
              component={route.component}
              key={route.path}
            />
          )
        }
      </Switch>
    </Suspense>
  );
}

export default withRouter(RouterSwitch);
